import {
  SET_NOTIFICATION_SETTING,
  SET_USER_SCHEDULE,
  SET_USER_SESSION,
  UPDATE_USER_SESSION,
} from "../actions/types";

const initialState = {
  notificationType: 1, // 1 - All notification
  userSchedule: {},
  user: {},
  userProfile: {},
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_NOTIFICATION_SETTING:
      return {
        ...state,
        notificationType: action.setting,
      };
      break;

    case SET_USER_SCHEDULE:
      return {
        ...state,
        userSchedule: action.userSchedule,
      }
      break;

    case SET_USER_SESSION:
      return {
        ...state,
        userProfile: action.userProfile,
      }
      break;

    case UPDATE_USER_SESSION:
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          isAvailable: action.isAvailable,
          useSchedule: action.useSchedule,
          unavailabilityReason: action.unavailabilityReason,
        },
      }
      break;

    default:
      return state;
  }
}
